import useEmpresa, { MODULO_MEU_WHATSAPP } from '@/contexts/useEmpresa'
import { toast } from 'react-toastify'
import './PixModalContent.scss'
import type { PagamentoPix } from '@/types/pagamento'
import { copyTextToClipboard } from '@/utils'
import PaymentResultFrame from './PaymentResultFrame'

interface PixModalContentProps {
    onClose: () => void
    pixModal: PagamentoPix
}

export default function PixModalContent({pixModal, onClose}: PixModalContentProps) {
    const { empresa } = useEmpresa()

    const whatsappMessage = empresa?.ModuloMeuWhatsapp && empresa?.Modulos?.includes(MODULO_MEU_WHATSAPP)
        ? `O número que irá enviar a mensagem é ${empresa.Telefone}`
        : ''

    return (
        <PaymentResultFrame
            badge="PIX"
            title="Pagamento com Pix"
            subtitle={`Após o registro do pagamento iremos enviar uma mensagem whatsapp para o número informado que a fatura foi paga.${whatsappMessage ? ` ${whatsappMessage}` : ''}`}
            actions={(
                <button type="button" onClick={onClose} className="btn btn-light-primary pix-modal-close-btn">
                    Fechar
                </button>
            )}
        >
            <div className="pix-modal-grid">
                <div className="pix-modal-card pix-modal-card-qrcode">
                    <div className="pix-modal-card-label">QR Code</div>
                    <img src={pixModal.qrcode} className="pix-modal-qrcode" alt="QrCode" />
                </div>

                <div className="pix-modal-card pix-modal-card-copy">
                    <div className="pix-modal-card-label">Copia e cola</div>
                    <textarea
                        title="Código copia e cola"
                        readOnly
                        className="form-control deposito-field-input pix-modal-copy-area"
                        rows={5}
                        spellCheck={false}
                        value={pixModal.emv ?? ''}
                    />
                    <button
                        type="button"
                        onClick={async () => {
                            const copied = await copyTextToClipboard(pixModal.emv ?? '')
                            if (copied) {
                                toast.success('Copiado com sucesso', { autoClose: 2000 })
                                return
                            }

                            toast.error('Não foi possível copiar o conteúdo.')
                        }}
                        className="btn btn-outline-primary copy-field-btn copy-field-btn-inline pix-modal-copy-btn"
                    >
                        Copiar código Pix
                    </button>
                </div>
            </div>
        </PaymentResultFrame>
    )
}
